<template>
    <div class="audio-play" v-show="audioSound">
        <!-- Button Play -->
        <template v-if="text && sender_type == 'bot' && !play && !loading">
            <button class="tts-icon" @click="activetextToaudio()" :disabled="inPlay">
                <i class="material-icons">play_circle_outline</i>
            </button>
        </template>
        <!-- Button Loader -->
        <template v-if="loading">
            <svg class="loader-icon" width="21" height="21" viewBox="0 0 50 50"
                style="animation: rotate 2s linear infinite;">
                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke="currentColor"
                    stroke-dasharray="31.415, 31.415" stroke-linecap="round"
                    style="animation: dash 1.5s ease-in-out infinite;">
                </circle>
            </svg>
        </template>

        <template v-if="playedIndex == index">
            <template v-if="play || paused">
                <!-- Button Pause -->
                <button @click="pauseAudio" class="pause-icon" :class="!paused ? 'rotation' : ''">
                    <i class="material-icons">pause_circle_outline</i>
                </button>
                <!-- Button Stop -->
                <button @click="stopAudio" class="stop-icon">
                    <i class="material-icons">stop_circle</i>
                </button>
            </template>
        </template>
    </div>
</template>

<script>

export default {
    name: "Audio_play",
    props: {
        text: {
            type: String,
            required: null
        },
        sender_type: {
            type: String,
            required: null
        },
        index: {
            type: Number,
            required: 0
        }
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        audioSound() {
            return this.$store.state.navigation.audioSound;
        },
        audioState() {
            return this.$store.state.navigation.audioState;
        },
        play() {
            return this.audioState.play;
        },
        inPlay() {
            return this.audioState.inPlay;
        },
        paused() {
            return this.audioState.paused;
        },
        playedIndex() {
            return this.audioState.indexPlayed;
        }
    },
    methods: {
        async activetextToaudio() {
            this.loading = true;
            //remove any html tag
            const text = this.text.replace(/<[^>]*>?/gm, '');
            try {
                await this.$store.dispatch('TRIGGER_AUDIO', {
                    text,
                    index: this.index
                })
                this.loading = false;
            } catch (error) {
                this.loading = false;
                //console.log(error);
            }
        },
        //function pour pause audio 
        pauseAudio() {
            this.$store.commit('PAUSE_AUDIO');
        },
        //function pour stop audio 
        stopAudio() {
            this.$store.commit('STOP_AUDIO');
        },
    }
}
</script>